import { camelCase, isArray, isObject, map, snakeCase } from 'lodash-es'

const UUID_SUFFIX_REGEX = /UUID$/
const ID_SUFFIX_REGEX = /ID$/

export const keyToCamelCase = (k: string) => {
	if (k.endsWith('_ids')) {
		const base = k.slice(0, -'_ids'.length)
		return `${camelCase(base)}IDs`
	}
	const suffixes = ['_uuid', '_id', '_url']
	for (const suffix of suffixes) {
		if (k.endsWith(suffix)) {
			const base = k.slice(0, -suffix.length)
			const suffixUpper = suffix.slice(1).toUpperCase()
			return camelCase(base) + suffixUpper
		}
	}
	return camelCase(k)
}

export const toCamelCase: any = (data: unknown) => {
	if (isArray(data)) {
		return map(data, toCamelCase)
	}

	if (isObject(data)) {
		const result: any = {}
		Object.keys(data).forEach(k => {
			const newKey = keyToCamelCase(k)
			result[newKey] = toCamelCase((data as any)[k])
		})
		return result
	}

	return data
}

export const toSnakeCase: any = (data: unknown) => {
	if (isArray(data)) {
		return map(data, toSnakeCase)
	}

	if (isObject(data)) {
		const result: any = {}
		Object.keys(data).forEach(k => {
			const key = k.toString().replace(UUID_SUFFIX_REGEX, 'Uuid').replace(ID_SUFFIX_REGEX, 'Id')
			const newKey = snakeCase(key)
			result[newKey] = toSnakeCase((data as any)[k])
		})
		return result
	}

	return data
}
